import { Box, Typography, TextField, IconButton, Dialog, DialogTitle, DialogContent, DialogActions, Button, Chip, CircularProgress, Modal} from "@mui/material";
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CloseIcon from '@mui/icons-material/Close';
import * as React from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import { useDispatch, useSelector } from "react-redux";
import { deleteCompany, getCompanyList, updatePage, updatePerPage, updateCompanyStatus } from "../../redux/actions/companyList";
import { useDebunce } from "../common/Debunce";
import AddIcon from '@mui/icons-material/Add';
import { ROUTE_COMPANY_NEW, ROUTE_COMPANY_EDIT } from "../../constants/routes";
import { useNavigate } from "react-router-dom";
import Avatar from '@mui/material/Avatar';
import moment from "moment";
interface Column {
  id: "no" | "company_name" | "industry" | "contact_person" | "email" | "phone_number" | "address" | "city" | "state" | "postal_code" | "country" | "website" | "description" | "logo_image_path" | "linkedin_profile" | "created_at" | "updated_at" | "no_of_employees" | "location" | "founded_in" | "headquarter" | "industry_operate_in" | "twitter_profile" | "facebook_profile" | "status" | "instagram_profile" | "actions";
  label: string;
  minWidth?: number;
  align?: 'right' | 'center';
  format?: (value: number) => string;
  render?: (value: any) => JSX.Element;
}

const CompanyList = () => {
  const [searchText, setSearchText] = React.useState("");
  const [deleteDialogOpen, setDeleteDialogOpen] = React.useState(false);
  const [activateDialogOpen, setActivateDialogOpen] = React.useState(false);
  const [companyToDelete, setCompanyToDelete] = React.useState<CompanyData | null>(null);
  const [companyToActivate, setCompanyToActivate] = React.useState<CompanyData | null>(null);
  const [isActivating, setIsActivating] = React.useState(false);
  const [isDeleting, setIsDeleting] = React.useState(false);
  const [isSearching, setIsSearching] = React.useState(false);
  const [displayList, setDisplayList] = React.useState<any[]>([]);
  const [previewModalOpen, setPreviewModalOpen] = React.useState(false);
  const [previewImageUrl, setPreviewImageUrl] = React.useState<string>("");
  const dispatch = useDispatch();
  const { list, totalCount, rowsPerPage, page } = useSelector((state: any) => state.companyList);
  const navigate = useNavigate();

  const handleLogoClick = (logoUrl: string) => {
    if (logoUrl) {
      setPreviewImageUrl(logoUrl);
      setPreviewModalOpen(true);
    }
  };

  const columns: readonly Column[] = [
    { id: 'no', label: 'No.', minWidth: 50 },
    { 
      id: 'logo_image_path', 
      label: 'Logo', 
      minWidth: 100, 
      align: 'center',
      render: (value: string) => (
        <Box display="flex" justifyContent="center">
          {value ? (
            <Box
              component="img"
            src={value} 
            alt="Company Logo" 
            onClick={() => handleLogoClick(value)}
            sx={{ 
              width: 40, 
              height: 40, 
                objectFit: 'contain',
                backgroundColor: "#eee",
                borderRadius: '4px',
                cursor: 'pointer',
              transition: 'opacity 0.2s, transform 0.2s',
                padding: '4px',
                '&:hover': {
                opacity: 0.8,
                transform: 'scale(1.1)',
                },
              }}
            />
          ) : (
            <Avatar 
              sx={{ 
                width: 40, 
                height: 40, 
                bgcolor: "#eee",
            }}
            variant="rounded"
          />
          )}
        </Box>
      )
    },
  { id: 'company_name', label: 'Company Name', minWidth: 170 },
  // { id: 'industry', label: 'Industry', minWidth: 150 },
  // { id: 'contact_person', label: 'Contact Person', minWidth: 150 },
  // { id: 'email', label: 'Email', minWidth: 200 },
  // { id: 'phone_number', label: 'Phone', minWidth: 150 },
  // { id: 'address', label: 'Address', minWidth: 200 },
  // { id: 'city', label: 'City', minWidth: 150 },
  // { id: 'state', label: 'State', minWidth: 150 },
  // { id: 'postal_code', label: 'Postal Code', minWidth: 120 },
  // { id: 'country', label: 'Country', minWidth: 150 },
  // { id: 'description', label: 'Description', minWidth: 300 },
  
  // { id: 'linkedin_profile', label: 'LinkedIn', minWidth: 200 },

  { id: 'no_of_employees', label: 'Employees', minWidth: 120, align: 'right' },
  { id: 'location', label: 'Location', minWidth: 150 },
  { id: 'founded_in', label: 'Founded In', minWidth: 100, align: 'right' },
  { id: 'headquarter', label: 'Headquarter', minWidth: 150 },
  // { id: 'industry_operate_in', label: 'Industry Operate In', minWidth: 250 },
  // { id: 'twitter_profile', label: 'Twitter', minWidth: 200 },
  // { id: 'facebook_profile', label: 'Facebook', minWidth: 200 },
  // { id: 'instagram_profile', label: 'Instagram', minWidth: 200 },
    { id: 'website', label: 'Website', minWidth: 200 },

  { 
    id: 'created_at', 
    label: 'Created At', 
    minWidth: 180,
    render: (value: string) => (
      <span>{value ? moment(value).format("DD MMM YYYY") : "-"}</span>
    )
  },
  { 
    id: 'updated_at', 
    label: 'Updated At', 
    minWidth: 180,
    render: (value: string) => (
      <span>{value ? moment(value).format("DD MMM YYYY") : "-"}</span>
    )
  },
  { id: 'status', label: 'Status', minWidth: 120 },
  { id: 'actions', label: 'Actions', minWidth: 100, align: 'center' },
];

interface CompanyData {
  companyId?: string;
  company_name: string;
  industry: string | null;
  contact_person: string;
  email: string | null;
  phone_number: string;
  address: string | null;
  city: string;
  state: string;
  postal_code: string | null;
  country: string | null;
  website: string;
  description: string;
  logo_image_path: string;
  linkedin_profile: string;
  created_at: string;
  updated_at: string;
  no_of_employees: number;
  location: string | null;
  founded_in: number;
  headquarter: string;
  industry_operate_in: string;
  twitter_profile: string | null;
  facebook_profile: string | null;
  status: string;
  instagram_profile: string | null;
  actions?: any; // For actions column
}

  // Status chip styling function
  const getStatusChip = (status: 'ACTIVE' | 'INACTIVE' | 'PENDING') => {
    const statusConfig = {
      ACTIVE: {
        color: '#4CAF50',
        backgroundColor: '#E8F5E8',
        label: 'Active'
      },
      INACTIVE: {
        color: '#F44336',
        backgroundColor: '#FFEBEE',
        label: 'Inactive'
      },
      PENDING: {
        color: '#FF9800',
        backgroundColor: '#FFF3E0',
        label: 'Pending'
      }
    };

    const config = statusConfig[status];
    
    return (
      <Chip
        label={config.label}
        size="small"
        sx={{
          backgroundColor: config.backgroundColor,
          color: config.color,
          fontWeight: 500,
          border: `1px solid ${config.color}20`,
          '&:hover': {
            backgroundColor: config.backgroundColor,
          }
        }}
      />
    );
  };

  const handleChangePage = (event: unknown, newPage: number) => {
    dispatch(updatePage(newPage + 1));
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    dispatch(updatePerPage(newRowsPerPage));
    // Reset to first page when changing rows per page
    dispatch(updatePage(1));
  };

  const handleDeleteClick = (companyName: any) => {
    setCompanyToDelete(companyName);
    setDeleteDialogOpen(true);
  };

  const handleActivateClick = (company: any) => {
    setCompanyToActivate(company);
    setActivateDialogOpen(true);
  };

  const handleDeleteConfirm = async () => {
    if(!companyToDelete?.companyId) return false;
    
    setIsDeleting(true);
    try {
      const deletedStatus = await dispatch(deleteCompany(companyToDelete?parseInt(companyToDelete?.companyId):0));
      if(deletedStatus){
        dispatch(getCompanyList({
          searchText: searchTextFetch??"",
          page: page,
          fetchSize: rowsPerPage,
          isPagination: true
        }));
        setDeleteDialogOpen(false);
        setCompanyToDelete(null);
      }
    } finally {
      setIsDeleting(false);
    }
  };

  const handleDeleteCancel = () => {
    setDeleteDialogOpen(false);
    setCompanyToDelete(null);
    setIsDeleting(false);
  };

  const handleActivateConfirm = async () => {
    if(!companyToActivate?.companyId) return false;
    
    setIsActivating(true);
    try {
      const activatedStatus = await dispatch(updateCompanyStatus(parseInt(companyToActivate.companyId), "ACTIVE"));
      if(activatedStatus){
        dispatch(getCompanyList({
          searchText: searchTextFetch??"",
          page: page,
          fetchSize: rowsPerPage,
          isPagination: true
        }));
        setActivateDialogOpen(false);
        setCompanyToActivate(null);
      }
    } finally {
      setIsActivating(false);
    }
  };

  const handleActivateCancel = () => {
    setActivateDialogOpen(false);
    setCompanyToActivate(null);
    setIsActivating(false);
  };

  const searchTextFetch = useDebunce(searchText, 300);

  // Handle search text changes - clear results immediately
  const handleSearchChange = (value: string) => {
    setSearchText(value);
    
    // Clear the display list immediately when user starts typing
    setDisplayList([]);
    setIsSearching(true);
    
    // Reset to first page when starting a new search
    if (value.trim() !== '') {
      dispatch(updatePage(1));
    } else {
      // If search is cleared, stop searching and show loading
      setIsSearching(false);
    }
  };

  // Update display list when new data arrives
  React.useEffect(() => {
    if (list && list.length >= 0) {
      // Debug: Log the incoming data
      console.log('New list data received:', list.length, 'items');
      console.log('Current displayList length:', displayList.length);
      
      // Remove duplicates based on companyId or company_name
      const uniqueList = list.filter((item: any, index: number, self: any[]) => 
        index === self.findIndex((t: any) => 
          (t.companyId && t.companyId === item.companyId) || 
          (!t.companyId && t.company_name === item.company_name)
        )
      );
      
      console.log('Filtered unique items:', uniqueList.length);
      setDisplayList(uniqueList);
      setIsSearching(false);
    }
  }, [list]);

  React.useEffect(() => {
    // Set searching state based on search text
    if (searchTextFetch.trim() !== '') {
      setIsSearching(true);
    } else {
      setIsSearching(false);
    }
    
    // Always use pagination for the main list view
    dispatch(getCompanyList({
      searchText: searchTextFetch,
      page: page,
      fetchSize: rowsPerPage,
      isPagination: true
    }));
  }, [rowsPerPage, page, searchTextFetch]);

  const createCompany = () => {
    navigate(ROUTE_COMPANY_NEW);
  };

  const handleEditClick = (company: CompanyData) => {
    if (company.companyId) {
      navigate(ROUTE_COMPANY_EDIT.replace(':id', company.companyId));
    }
  };

  return (
    <Box
      sx={{
        backgroundColor: "#ffffff",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >

      <Box
        sx={{
          padding: "26px",
          width: "100%",
        }}
      >

        {/* Header with Search and Create Button */}
        <Box sx={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center',
          marginBottom: '20px',
          paddingX: '32px'
        }}>
           {/* Search Box */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            width: "359px",
            height: "45px",
            border: "1px solid #756DE9",
            borderRadius: "100px",
            position: "relative",
          }}
        >
          <TextField
            variant="standard"
            placeholder="Search..."
            sx={{
              width: "100%",
              paddingLeft: "15px",
              fontSize: "16px",
              "& .MuiInput-underline:before": { borderBottom: "none" },
              "& .MuiInput-underline:after": { borderBottom: "none" },
            }}
            InputProps={{
              disableUnderline: true,
            }}
            onChange={(e) => handleSearchChange(e.target.value)}
            value={searchText}
          />

          <IconButton
            sx={{
              position: "absolute",
              right: "10px",
              padding: "0",
            }}
          >
            <Box
              component="img"
              src="/images/client-website/search-line.png"
              alt="search icon"
              sx={{
                width: "24px",
                height: "24px",
              }}
            />
          </IconButton>
        </Box>

        {/* Create New User Button */}
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={() => createCompany()}
            sx={{
              backgroundColor: '#756DE9',
              color: 'white',
              borderRadius: '24px',
              textTransform: 'none',
              fontWeight: 600,
              paddingX: '20px',
              paddingY: '10px',
              '&:hover': {
                backgroundColor: '#5f5bc4',
              }
            }}
          >
            Create New Company
          </Button>
        </Box>

        {/* Table */}
        <Box sx={{ display: "flex", justifyContent: "flex-end", marginTop: "20px", padding: "0px 30px" }}>
          <Paper sx={{ width: '100%', overflow: 'hidden', borderRadius: 4 }} elevation={3}>
            <TableContainer sx={{ maxHeight: 560, minHeight: 580, position: 'relative' }}>
              {/* Loading State */}
              {isSearching && (
                <Box sx={{ 
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  display: 'flex', 
                  flexDirection: 'column',
                  alignItems: 'center', 
                  justifyContent: 'center', 
                  gap: 2,
                  zIndex: 10,
                  backgroundColor: 'rgba(255, 255, 255, 0.9)',
                  padding: '20px',
                  borderRadius: '8px',
                  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)'
                }}>
                  <CircularProgress size={32} sx={{ color: '#756DE9' }} />
                  <Typography sx={{ color: '#777777', fontSize: '1rem' }}>
                    Searching companies...
                  </Typography>
                </Box>
              )}

              {/* Empty State */}
              {!isSearching && displayList.length === 0 && (
                <Box sx={{ 
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  display: 'flex', 
                  flexDirection: 'column',
                  alignItems: 'center', 
                  justifyContent: 'center', 
                  gap: 2,
                  zIndex: 10,
                  backgroundColor: 'rgba(255, 255, 255, 0.9)',
                  padding: '20px',
                  borderRadius: '8px',
                  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)'
                }}>
                  <Typography sx={{ 
                    color: '#777777', 
                    fontSize: '1.1rem',
                    fontWeight: 500,
                    textAlign: 'center'
                  }}>
                    {searchText ? "No companies found matching your search." : "No companies found."}
                  </Typography>
                  {searchText && (
                    <Typography sx={{ 
                      color: '#999999', 
                      fontSize: '0.9rem',
                      textAlign: 'center'
                    }}>
                      Try adjusting your search terms or filters.
                    </Typography>
                  )}
                </Box>
              )}

              <Table stickyHeader aria-label="sticky table">
                <TableHead style={{ backgroundColor: "#756eea" }}>
                  <TableRow>
                    {columns.map((column) => (
                      <TableCell
                        key={column.id}
                        align={column.align}
                        style={{ 
                          minWidth: column.minWidth, 
                          backgroundColor: "#756eea", 
                          color: "#fff", 
                          fontWeight: "600",
                          ...(column.id === 'status' || column.id === 'actions' ? {
                            position: 'sticky',
                            right: column.id === 'actions' ? 0 : 100,
                            zIndex: 10,
                            backgroundColor: "#756eea",
                          } : {})
                        }}
                      >
                        {column.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {!isSearching && displayList.map((row: any, index: number) => {
                      return (
                        <TableRow hover role="checkbox" tabIndex={-1} key={`${row.companyId || row.company_name}-${index}`}>
                          {columns.map((column) => {
                            if(column.id === 'no'){
                              return (
                                <TableCell key={column.id} align={column.align || 'left'}>
                                  {(page - 1) * rowsPerPage + displayList.indexOf(row) + 1}
                                </TableCell>
                              );
                            }
                            if (column.id === 'actions') {
                              return (
                                <TableCell 
                                  key={column.id} 
                                  align={column.align}
                                  style={{
                                    position: 'sticky',
                                    right: 0,
                                    zIndex: 9,
                                    backgroundColor: '#fff',
                                    borderLeft: '1px solid #e0e0e0',
                                  }}
                                >
                                  <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center' }}>
                                    <IconButton
                                      onClick={() => handleEditClick(row)}
                                      sx={{
                                        color: '#756DE9',
                                        '&:hover': {
                                          backgroundColor: 'rgba(117, 109, 233, 0.08)',
                                        },
                                      }}
                                      title="Edit Company"
                                    >
                                      <EditIcon />
                                    </IconButton>
                                    {row.status === "ACTIVE" ? (
                                      <IconButton
                                        onClick={() => handleDeleteClick(row)}
                                        sx={{
                                          color: '#f44336',
                                          '&:hover': {
                                            backgroundColor: 'rgba(244, 67, 54, 0.08)',
                                          },
                                        }}
                                        title="Delete Company"
                                      >
                                        <DeleteIcon />
                                      </IconButton>
                                    ) : (
                                      <IconButton
                                        onClick={() => handleActivateClick(row)}
                                        sx={{
                                          color: '#4CAF50',
                                          '&:hover': {
                                            backgroundColor: 'rgba(76, 175, 80, 0.08)',
                                          },
                                        }}
                                        title="Activate Company"
                                      >
                                        <CheckCircleIcon />
                                      </IconButton>
                                    )}
                                  </Box>
                                </TableCell>
                              );
                            }
                            if (column.id === 'status') {
                              return (
                                <TableCell 
                                  key={column.id} 
                                  align={column.align || 'left'}
                                  style={{
                                    position: 'sticky',
                                    right: 100,
                                    zIndex: 9,
                                    backgroundColor: '#fff',
                                    borderLeft: '1px solid #e0e0e0',
                                  }}
                                >
                                  {getStatusChip(row.status)}
                                </TableCell>
                              );
                            }
                            
                            const value = row[column.id as keyof CompanyData];
                            return (
                              <TableCell key={column.id} align={column.align}>
                                {column.render ? column.render(value) : (
                                <p 
                                  style={(column.id === "description" || column.id === "industry_operate_in") ? {
                                  maxWidth: 250, // adjust width for description column
                                  whiteSpace: "normal",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  display: "-webkit-box",
                                  WebkitLineClamp: 2,
                                  WebkitBoxOrient: "vertical",
                                  height: 40,
                                } : {
                                  height: 40
                                }}
                                >
                                  {column.format && typeof value === 'number'
                                  ? column.format(value)
                                  : value ?? "-"}
                                </p>  
                                )}
                              </TableCell>
                            );
                          })}
                        </TableRow>
                      );
                    })}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, 100]}
              component="div"
              count={totalCount}
              rowsPerPage={rowsPerPage}
              page={page-1}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Paper>
        </Box>
      </Box>

      {/* Delete Confirmation Dialog */}
      <Dialog
        open={deleteDialogOpen}
        onClose={handleDeleteCancel}
        aria-labelledby="delete-dialog-title"
        aria-describedby="delete-dialog-description"
        PaperProps={{
          sx: {
            borderRadius: 3,
            padding: 1,
          }
        }}
      >
        <DialogTitle 
          id="delete-dialog-title"
          sx={{
            color: '#f44336',
            fontWeight: 600,
            fontSize: '1.25rem',
            textAlign: 'center',
          }}
        >
          Confirm Delete
        </DialogTitle>
        <DialogContent>
          <Typography
            id="delete-dialog-description"
            sx={{
              textAlign: 'center',
              color: '#666',
              fontSize: '1rem',
              padding: '8px 0',
            }}
          >
            Are you sure you want to delete <strong>{companyToDelete?.company_name}</strong>? 
          
          </Typography>
        </DialogContent>
        <DialogActions sx={{ justifyContent: 'center', gap: 2, padding: '16px 24px' }}>
          <Button
            onClick={handleDeleteCancel}
            variant="outlined"
            disabled={isDeleting}
            sx={{
              borderColor: '#756DE9',
              color: '#756DE9',
              '&:hover': {
                borderColor: '#5a52d5',
                backgroundColor: 'rgba(117, 109, 233, 0.08)',
              },
              borderRadius: 2,
              paddingX: 3,
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleDeleteConfirm}
            variant="contained"
            disabled={isDeleting}
            sx={{
              backgroundColor: '#f44336',
              '&:hover': {
                backgroundColor: '#d32f2f',
              },
              borderRadius: 2,
              paddingX: 3,
              minWidth: 100,
            }}
          >
            {isDeleting ? (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <CircularProgress size={16} sx={{ color: 'white' }} />
                Deleting...
              </Box>
            ) : (
              'Delete'
            )}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Activate Confirmation Dialog */}
      <Dialog
        open={activateDialogOpen}
        onClose={handleActivateCancel}
        aria-labelledby="activate-dialog-title"
        aria-describedby="activate-dialog-description"
        PaperProps={{
          sx: {
            borderRadius: 3,
            padding: 1,
          }
        }}
      >
        <DialogTitle 
          id="activate-dialog-title"
          sx={{
            color: '#4CAF50',
            fontWeight: 600,
            fontSize: '1.25rem',
            textAlign: 'center',
          }}
        >
          Confirm Activation
        </DialogTitle>
        <DialogContent>
          <Typography
            id="activate-dialog-description"
            sx={{
              textAlign: 'center',
              color: '#666',
              fontSize: '1rem',
              padding: '8px 0',
            }}
          >
            Are you sure you want to activate <strong>{companyToActivate?.company_name}</strong>? 
            <br />
            This will make the company active and visible to users.
          </Typography>
        </DialogContent>
        <DialogActions sx={{ justifyContent: 'center', gap: 2, padding: '16px 24px' }}>
          <Button
            onClick={handleActivateCancel}
            variant="outlined"
            disabled={isActivating}
            sx={{
              borderColor: '#756DE9',
              color: '#756DE9',
              '&:hover': {
                borderColor: '#5a52d5',
                backgroundColor: 'rgba(117, 109, 233, 0.08)',
              },
              borderRadius: 2,
              paddingX: 3,
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleActivateConfirm}
            variant="contained"
            disabled={isActivating}
            sx={{
              backgroundColor: '#4CAF50',
              '&:hover': {
                backgroundColor: '#45a049',
              },
              borderRadius: 2,
              paddingX: 3,
              minWidth: 100,
            }}
          >
            {isActivating ? (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <CircularProgress size={16} sx={{ color: 'white' }} />
                Activating...
              </Box>
            ) : (
              'Activate'
            )}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Image Preview Modal */}
      <Modal
        open={previewModalOpen}
        onClose={() => setPreviewModalOpen(false)}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Box
          sx={{
            position: 'relative',
            maxWidth: '90vw',
            maxHeight: '90vh',
            backgroundColor: '#fff',
            borderRadius: '12px',
            padding: '20px',
            outline: 'none',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <IconButton
            onClick={() => setPreviewModalOpen(false)}
            sx={{
              position: 'absolute',
              top: 8,
              right: 8,
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              color: '#fff',
              '&:hover': {
                backgroundColor: 'rgba(0, 0, 0, 0.7)',
              },
            }}
          >
            <CloseIcon />
          </IconButton>
          <img
            src={previewImageUrl}
            alt="Company Logo Preview"
            style={{
              maxWidth: '100%',
              maxHeight: '80vh',
              objectFit: 'contain',
              borderRadius: '8px',
            }}
          />
          <Typography
            variant="body2"
            sx={{
              marginTop: 2,
              color: '#666',
              fontSize: '14px',
            }}
          >
            Company Logo Preview
          </Typography>
        </Box>
      </Modal>
    </Box>
  );
};

export default CompanyList;